import 'script-loader!amp';
import React, { PropTypes }   from 'react';
import ReactDOM               from 'react-dom';
import Reflux                 from 'reflux';
import $                      from 'jquery';
import cx                     from 'classnames';
import PlayerControls         from './player-controls';
import VideoStore             from './video-store';
import Utils                  from 'medscape/utils';
import Settings               from './configs/settings';
import VideoTrackingStore     from './video-tracking-store';
import TapForSoundLayer       from './tap-for-sound/tap-for-sound-layer';
import {
  BrowserRouter as Router,
  Route,
  Link
} from 'react-router-dom';

/*
    Video Reflux/React Component

    Wrapper for Akamai's AMP video player.
    Disables custom Player Controls for mobile devices
*/
export default class Video extends Reflux.Component{
  constructor(props) {
    super(props);
    this.state = {};
    this.mediaEl = null;
    this.store = VideoStore.get(props.config, this.props.route);
    this.tracking = VideoTrackingStore.get(props.config, this.props.route);

    this.VideoActions = this.store.VideoActions;
    this.ControlsActions = this.store.ControlsActions;
    this.mediaApi = null;

  }
  shouldComponentUpdate(nextProps, nextState){
    return (nextProps.config["config-id"]!=this.props.config["config-id"])
  }
  componentDidMount() {
    this.create();
  }
  componentDidUpdate(prevProps,prevState) {
    this.create();
  }
  componentWillUnmount() {
    this.store.stopListeningToAll();
    this.VideoActions.destroy();
    this.tracking.stopListeningToAll();
    VideoStore.clearCache();
    VideoTrackingStore.clearCache();
  }
  getAmpConfig(video) {
    let config = video;
    const Config = {
      media: {
        autoplay: false
      },
      playsinline: true,
      controls: {
        mode: Utils.isMobile() ? "auto" : "none",
        native: Utils.isMobile()
      },
      captioning: {
        enabled: true
      },
      mode: 'auto'
    };
    let settings = new Settings(config);
    let _config = $.extend(true,Config, settings.vConfig);
    let isFF = !(window.mozInnerScreenX == null),
        isIE = window.navigator.userAgent.indexOf('MSIE ') > 0 || !!window.navigator.userAgent.match(/Trident.*rv\:11\./),
        imgSvrPath = window.image_server_url || '//img.preview.webmd.com/dtmcms/preview',
        basePluginUrl = window.location.host.indexOf("localhost") > -1 ? '/resources/plugins/' : imgSvrPath + '/webmd/consumer_assets/site_images/amd_modules/video2/1/lib/',
        baseSkinUrl = window.location.host.indexOf("localhost") > -1 ? '/amp/' : imgSvrPath + '/webmd/consumer_assets/site_images/amd_modules/video2/1/lib/',
        coreConfig = settings.vConfig;
    coreConfig.flash.vars.auto_play_override = settings.autoplay || false;
    // NOTE: this is still temporary, the default plugin and skin url will be hard coded in the wxml file
    while (coreConfig.flash.xml.indexOf('{basePluginUrl}') !== -1) {
      coreConfig.flash.xml = coreConfig.flash.xml.replace('{basePluginUrl}', basePluginUrl);
    }
    while (coreConfig.flash.xml.indexOf('{baseSkinUrl}') !== -1) {
      coreConfig.flash.xml = coreConfig.flash.xml.replace('{baseSkinUrl}', baseSkinUrl);
    }
    coreConfig = $.extend(true, coreConfig, _config);
    if (isFF === true || isIE === true) {
      coreConfig['flash']['params'] = {
        'wmode': 'transparent'
      };
    }
    coreConfig.media.title = video.title ? video.title : '';
    coreConfig.media.metadata = coreConfig.media.metadata || {};
    coreConfig.media.metadata.videoId = video["config-id"];
    return coreConfig;
  }
  create() {

    let $this = $(ReactDOM.findDOMNode(this));
    // Delay loading akamai media player, otherwise it will break React's event listeners
    let playerEl = $this.find('.player-container')[0];
    const ampConfig = this.getAmpConfig(this.props.config);
    this.store = VideoStore.get(this.props.config, this.props.route);
    this.tracking = VideoTrackingStore.get(this.props.config, this.props.route);
    this.VideoActions = this.store.VideoActions;
    this.ControlsActions = this.store.ControlsActions;
    let mediaApi = this.mediaApi;
    this.tracking.mediaApi = mediaApi;
    if(mediaApi) {
      let isMuted = mediaApi.getMuted();
      mediaApi.setMedia(ampConfig.media);
      setTimeout(()=>{
        mediaApi.setMuted(isMuted);
      },250);
    } else {
      setTimeout(()=> {
        this.mediaApi = window.akamai.amp.AMP.create(playerEl, ampConfig, ()=>{
          let mediaElement = this.mediaApi.getMediaElement();
          if(!Utils.isMobile()) {
            mediaElement.controls = false;
          }
          this.VideoActions.ready(this.mediaApi);
          if(typeof this.props.setReady !== 'undefined') {
            this.props.setReady()
          }
        });
        this.props.setAmp(this.mediaApi);
      },500);
    }
  }
  getControls() {
    if(Utils.isMobile()) {
      return false;
    } else {
      return ( <PlayerControls config-id={this.props.config["config-id"]} route={this.props.route} /> )
    }
  }
  getTitle() {
    if(this.props.config.title.length==0) {
      return false;
    }
    return (<h1>{ this.props.config.title}</h1>);
  }
  getPageTitle() {
    if(this.props.config["page-title"].length==0) {
      return Utils.getDangerousHtml('');
    }
    let pageTitle = Utils.getDangerousHtml(this.props.config["page-title"]);
    return pageTitle
  }
  doSetMuted(flag=this.mediaApi.getMuted()){
    if(this.mediaApi!=null) {
      if(this.mediaApi.playState === 'ready') {
        this.mediaApi.play();
      }
      if(flag!=this.mediaApi.getMuted()) {
        this.mediaApi.setMuted(flag);
      }
    }
  }
  render() {
    let title = this.getPageTitle(),
      className = cx({
      'video-container': true,
      'isMobile': Utils.isMobile()
    });
    const Props = {
      id: this.props.id,
      className: className
    },
    TapForSoundProps = {
      config: this.props.config["config-id"],
      onSetMuted: this.doSetMuted.bind(this),
      route: this.props.route
    };
    return (
      <div className="video-component">
        <h1 dangerouslySetInnerHTML={title}></h1>
        <div className="player-container">
          <div {...Props}>
             <TapForSoundLayer {...TapForSoundProps} />
            {this.getControls()}
          </div>
        </div>
      </div>
    )
  } // render
}

Video.propTypes={
  'id': PropTypes.string,
  'config': PropTypes.object,
  'onVideoEnded': PropTypes.func
}
Video.defaultProps={
  'onVideoEnded': ()=>{}
}



// WEBPACK FOOTER //
// ./medscape_modules/video/video.jsx